import { render, staticRenderFns } from "./MenuReportSales.vue?vue&type=template&id=4a969d9f&scoped=true&"
import script from "./MenuReportSales.vue?vue&type=script&lang=js&"
export * from "./MenuReportSales.vue?vue&type=script&lang=js&"
import style0 from "./MenuReportSales.vue?vue&type=style&index=0&id=4a969d9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a969d9f",
  null
  
)

export default component.exports